<template>
  <section class="open-positions-module-component">
    <div class="inner-container">
      <h2 class="header-3 pl-4 text-bicara-charcoal lg:pl-0">Open Positions</h2>
      <div
        class="positions-content pl-4 lg:pl-0"
        v-html="data.Instructions.content"></div>
      <div
        v-if="!isLoading"
        class="open-positions">
        <SinglePosition
          v-for="position in PositionsData"
          :key="position.id"
          :position="position" />
      </div>
      <div
        v-else
        class="open-positions">
        <div
          role="status"
          class="flex h-auto animate-pulse flex-col items-start justify-between gap-4 border-b
            border-black py-4 pt-8 lg:flex-row lg:items-center">
          <div class="h-auto w-full max-w-full lg:max-w-[30%]">
            <div class="mb-4 h-2.5 w-[70%] rounded-full bg-gray-400"></div>
            <div class="mb-4 h-8 rounded-full bg-gray-400"></div>
          </div>
          <div class="flex h-auto w-fit max-w-full gap-2">
            <div class="mb-4 h-10 w-32 rounded-full bg-gray-400"></div>
            <div class="mb-4 h-10 w-10 rounded-full bg-gray-400"></div>
          </div>
          <span class="sr-only">Loading...</span>
        </div>
        <div
          role="status"
          class="flex h-auto animate-pulse flex-col items-start justify-between gap-4 border-b
            border-black py-4 pt-8 lg:flex-row lg:items-center">
          <div class="h-auto w-full max-w-full lg:max-w-[30%]">
            <div class="mb-4 h-2.5 w-[70%] rounded-full bg-gray-400"></div>
            <div class="mb-4 h-8 rounded-full bg-gray-400"></div>
          </div>
          <div class="flex h-auto w-fit max-w-full gap-2">
            <div class="mb-4 h-10 w-32 rounded-full bg-gray-400"></div>
            <div class="mb-4 h-10 w-10 rounded-full bg-gray-400"></div>
          </div>
          <span class="sr-only">Loading...</span>
        </div>
        <div
          role="status"
          class="flex h-auto animate-pulse flex-col items-start justify-between gap-4 border-b
            border-black py-4 pt-8 lg:flex-row lg:items-center">
          <div class="h-auto w-full max-w-full lg:max-w-[30%]">
            <div class="mb-4 h-2.5 w-[70%] rounded-full bg-gray-400"></div>
            <div class="mb-4 h-8 rounded-full bg-gray-400"></div>
          </div>
          <div class="flex h-auto w-fit max-w-full gap-2">
            <div class="mb-4 h-10 w-32 rounded-full bg-gray-400"></div>
            <div class="mb-4 h-10 w-10 rounded-full bg-gray-400"></div>
          </div>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "OpenPositionsComponent",
  "CLASSNAME": "open-positions-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */
import { onBeforeMount, ref } from 'vue'
import useGQL from '@/composables/useGQL.js'
import SinglePosition from '@/components/utility/SinglePosition.vue'
const { gqlQuery } = useGQL()
const isLoading = ref(true)
const PositionsData = ref([])

defineProps(['data'])

const initialQuery = async () => {
  isLoading.value = true

  const data = await gqlQuery(`
    query BammbooHRJobs {
      bambooHRJobs(status: OPEN) {
        id
        department {
          label
        }
        title {
          label
        }
        location {
          address {
            city
            state
          }
        }
        postingUrl
      }
    }
    `)
  PositionsData.value = data.data.bambooHRJobs
  isLoading.value = false
}

onBeforeMount(async () => await initialQuery())
</script>

<style lang="scss">
.open-positions-module-component {
  @apply bg-bicara-white pb-10;
  .inner-container {
    @apply mx-auto px-2 lg:px-0;
    .positions-content {
      @apply w-full pt-6 text-bicara-charcoal;
      a {
        @apply text-bicara-dark-blue transition-colors duration-300 ease-in-out;
        &:hover {
          @apply text-bicara-blue underline;
        }
      }
    }
    .open-positions {
      @apply my-8 rounded-2xl border border-bicara-dark-blue px-4 py-6 lg:px-8;
    }
  }
}
</style>
